module.exports = __webpack_public_path__ + "assets/2_1_3_IFOK_WIM_SOUVERENITY_TECH_platform_for_svg_je.775a73c2.svg";